{
  "general": {
    "noPermission": "Vous n'avez pas l'autorisation de voir les paramètres système.",
    "loading": "Chargement des paramètres généraux",
    "versionLabel": "Version",
    "lastEditedBy": "Dernière modification par {{name}}",
    "reload": "Recharger",
    "platformIdentity": {
      "title": "Identité de la plateforme",
      "description": "Image de marque affichée sur les portails admin, marchand et fournisseur."
    },
    "platformName": {
      "label": "Nom de la plateforme",
      "hint": "2 à 100 caractères."
    },
    "logo": {
      "label": "Logo",
      "helper": "PNG / JPEG / SVG ≤ 5 Mo"
    },
    "favicon": {
      "label": "Favicon",
      "helper": "ICO / PNG / SVG ≤ 5 Mo"
    },
    "localeTime": {
      "title": "Langue & heure",
      "description": "Valeurs par défaut appliquées lorsque l'utilisateur n'a pas défini sa préférence personnelle."
    },
    "defaultLocale": {
      "label": "Langue par défaut"
    },
    "defaultTimezone": {
      "label": "Fuseau horaire par défaut (IANA)"
    },
    "dateFormat": {
      "label": "Format de date par défaut",
      "options": {
        "vi": "DD/MM/YYYY (vietnamien)",
        "us": "MM/DD/YYYY (États-Unis)",
        "iso": "YYYY-MM-DD (ISO 8601)"
      }
    },
    "sessionTimeout": {
      "label": "Délai d'expiration de session (minutes)",
      "hint": "Entre 5 et 480 minutes."
    },
    "maintenance": {
      "title": "Mode maintenance",
      "description": "Activer la maintenance en direct nécessite une double approbation. Les modifications ici ne font que préparer la configuration — la tâche 50 gère le flux d'activation / désactivation.",
      "bannerActive": "La maintenance est actuellement marquée ACTIVE dans la configuration préparée — soumettez-la via le flux de double approbation avant qu'elle ne prenne effet.",
      "bannerInactive": "La maintenance n'est pas active. Les bascules préparées ne seront pas déployées sans le flux de double approbation.",
      "activeLabel": "Active (préparée)",
      "optionInactive": "Inactive",
      "optionActive": "Active (nécessite une approbation)",
      "messageLabel": "Message de bannière",
      "messagePlaceholder": "Nous mettons à niveau le système — de retour sous peu.",
      "durationLabel": "Durée estimée (heures, 0-168)",
      "bypassLabel": "IP de contournement (séparées par des virgules)",
      "bypassPlaceholder": "10.0.0.1, 192.168.1.42"
    }
  },
  "merchantConfigs": {
    "noPermission": "Vous n'avez pas l'autorisation de voir les paramètres système.",
    "loading": "Chargement des configurations marchand",
    "versionLabel": "Version",
    "lastEditedBy": "Dernière modification par {{name}}",
    "reload": "Recharger",
    "invalidJsonFallback": "JSON invalide",
    "draftSignup": {
      "title": "Comportement brouillon & inscription",
      "description": "Valeurs de cycle de vie par défaut appliquées à chaque marchand nouvellement créé."
    },
    "autoCancel": {
      "label": "Annuler le brouillon après (minutes)",
      "hint": "0 désactive l'annulation automatique des marchands en brouillon."
    },
    "survey": {
      "label": "ID du sondage d'inscription",
      "placeholder": "(laisser vide pour désactiver le sondage)"
    },
    "tier": {
      "title": "Attribution de niveau",
      "description": "Période sur laquelle le volume du marchand est agrégé pour calculer l'appartenance au niveau."
    },
    "tierWindow": {
      "label": "Fenêtre d'évaluation de niveau",
      "lifetime": "À vie",
      "lastDays": "{{days}} derniers jours"
    },
    "tierRules": {
      "label": "Règles de niveau (tableau JSON)",
      "parseError": "Erreur d'analyse JSON : {{message}}",
      "hint": "Chaque entrée est { \"tier\": \"...\", \"criteria\": { ... } }."
    },
    "creditRules": {
      "title": "Règles de crédit par défaut",
      "description": "Enregistrement JSON libre. Validé côté serveur selon le schéma de l'espace de noms marchand.",
      "parseError": "Erreur d'analyse JSON : {{message}}"
    },
    "atRisk": {
      "title": "Seuils Marchand à risque",
      "description": "Seuils de déclenchement qui placent un marchand dans la cohorte À risque affichée sur le tableau de bord SuperAdmin.",
      "lowRating": "Note faible en dessous de",
      "rejection": "Taux de rejet élevé au-dessus de (%)",
      "complaintCount": "Pic de réclamations (nombre)",
      "complaintWindow": "Fenêtre de réclamation (heures)"
    }
  },
  "orderConfigs": {
    "loading": "Chargement des paramètres de commande…",
    "loadErrorTitle": "Échec du chargement des paramètres de commande",
    "loadErrorFallback": "Échec du chargement des paramètres de commande — veuillez réessayer.",
    "saveErrorFallback": "Échec de l'enregistrement des paramètres de commande — veuillez réessayer.",
    "retry": "Réessayer",
    "heading": "Configuration des commandes",
    "description": "Configurez les taux de change (FX), la numérotation des factures, l'auto-push et les seuils d'escalade SLA des commandes. Chaque enregistrement écrit un journal d'audit + incrémente la version.",
    "conflict": {
      "title": "La version a changé",
      "fallback": "Les paramètres ont été mis à jour par quelqu'un d'autre pendant votre édition.",
      "reloadHint": "Veuillez recharger la page et réessayer.",
      "reload": "Recharger depuis le serveur"
    },
    "saved": "Enregistré (version {{version}}).",
    "fx": {
      "legend": "Taux de change (FX)",
      "sourceLabel": "Source du taux",
      "spreadLabel": "Spread (%) — marge ajoutée au taux de base"
    },
    "fxSourceOptions": {
      "ecb": "ECB (Banque centrale européenne)",
      "xe": "XE.com",
      "manual": "Manuel (saisie admin)"
    },
    "invoice": {
      "legend": "Numérotation des factures",
      "patternLabel": "Modèle de numérotation (jetons : YYYY, MM, DD, XXXXX)",
      "patternValid": "Modèle valide — doit commencer par « INV- ».",
      "patternInvalid": "Modèle invalide — doit commencer par « INV- ».",
      "previewLabel": "Aperçu :",
      "cronLabel": "Cron de génération automatique des factures (format cron à 5 champs)"
    },
    "autoPush": {
      "legend": "Auto-push & escalade SLA",
      "delayLabel": "Délai d'auto-push (secondes) — temps d'attente avant d'envoyer la commande au vendor",
      "slaLabel": "SLA d'escalade de stock faible (heures) — par défaut 48h",
      "shippingZonesLabel": "Lien des zones d'expédition (URL — page externe de gestion des zones, optionnel)"
    },
    "capacity": {
      "legend": "Seuils d'alerte de capacité (par défaut 80/95/100)",
      "low": "Faible (alerte précoce)",
      "warning": "Avertissement",
      "critical": "Critique"
    },
    "dirtyIndicator": "Modifications non enregistrées",
    "versionIndicator": "Version {{version}}",
    "discard": "Annuler les modifications",
    "save": "Enregistrer les modifications",
    "saving": "Enregistrement…"
  },
  "vendorConfigs": {
    "noPermission": "Vous n'avez pas la permission de voir les paramètres système.",
    "loading": "Chargement de la configuration vendor",
    "versionLabel": "Version",
    "lastEditedBy": "Dernière modification par {{name}}",
    "reload": "Recharger",
    "payouts": {
      "title": "Paiements",
      "description": "Cadence et périodes de rétention par palier que respectent les paiements aux vendors.",
      "scheduleLabel": "Calendrier de paiement"
    },
    "payoutScheduleOptions": {
      "weekly_friday": "Hebdomadaire (vendredi)",
      "biweekly": "Toutes les deux semaines",
      "monthly_first": "Mensuel (le 1er)",
      "monthly_last": "Mensuel (dernier jour)",
      "on_demand": "À la demande"
    },
    "holdTier": {
      "legend": "Période de rétention par palier (jours)",
      "empty": "Aucun palier de rétention configuré. Utilisez « Ajouter un palier » pour créer les valeurs par défaut tier1=7 / tier2=14 / tier3=21 (selon PLAN).",
      "remove": "Supprimer",
      "add": "Ajouter un palier"
    },
    "capacity": {
      "title": "Alertes de capacité",
      "description": "Seuils d'utilisation à partir desquels la plateforme affiche des avertissements de capacité sur les tableaux de bord SuperAdmin et vendor.",
      "low": "Faible (%)",
      "warning": "Avertissement (%)",
      "critical": "Critique (%)"
    },
    "atRisk": {
      "title": "Seuils Vendor At-Risk",
      "description": "Même structure que le panneau At-Risk du merchant — ces seuils déclenchent le widget vendor-at-risk du SuperAdmin.",
      "lowRating": "Note faible en dessous de",
      "highRejection": "Taux de rejet élevé au-dessus de (%)",
      "complaintCount": "Pic de réclamations (nombre)",
      "complaintWindow": "Fenêtre de réclamations (heures)"
    },
    "lowStock": {
      "title": "SLA d'escalade de stock faible",
      "description": "Délai d'attente du système avant d'escalader une alerte de stock faible d'un vendor vers la file SuperAdmin.",
      "slaLabel": "SLA d'escalade (heures, 1-168, par défaut 48)"
    },
    "slaThresholds": {
      "title": "Seuils SLA par défaut",
      "descBefore": "Carte JSON libre d'étape → minutes (par ex.",
      "descAfter": ").",
      "jsonLabel": "default_sla_thresholds (JSON)",
      "parseError": "Erreur d'analyse JSON : {{message}}",
      "invalidJson": "JSON invalide"
    }
  },
  "notificationsTab": {
    "loading": "Chargement des paramètres Notifications…",
    "loadErrorTitle": "Échec du chargement des paramètres Notifications",
    "loadError": "Impossible de charger les paramètres Notifications — veuillez réessayer.",
    "retry": "Réessayer",
    "heading": "Notifications",
    "description": "Configurez la matrice événement × canal, les heures calmes (DND), le résumé quotidien et les fournisseurs de passerelle (SMS/Email/Push). Selon, les clés secrètes sont renouvelées dans l'onglet Sécurité.",
    "versionConflictTitle": "Version modifiée",
    "versionConflictDefault": "Les paramètres ont été mis à jour par quelqu'un d'autre pendant votre modification.",
    "versionConflictSuffix": "Veuillez recharger la page et réessayer.",
    "reload": "Recharger depuis le serveur",
    "saveErrorFallback": "Échec de l'enregistrement des paramètres Notifications — veuillez réessayer.",
    "saved": "Enregistré (version {{version}}).",
    "matrix": {
      "legend": "Catalogue d'événements × Matrice de canaux",
      "eventHeader": "Événement",
      "cellAria": "{{event}} via {{channel}}"
    },
    "channels": {
      "in_app": "Dans l'app",
      "email": "E-mail",
      "push": "Push",
      "sms": "SMS",
      "slack": "Slack",
      "lark": "Lark"
    },
    "quietHours": {
      "legend": "Heures calmes (DND) + Résumé quotidien",
      "start": "Début des heures calmes",
      "end": "Fin des heures calmes",
      "timezone": "Fuseau horaire (IANA)",
      "digestEnable": "Activer le résumé quotidien (regrouper les notifications du jour)",
      "digestTime": "Heure d'envoi (locale)",
      "timezonePlaceholder": "Asia/Bangkok"
    },
    "gateways": {
      "legend": "Fournisseurs de passerelle",
      "enable": "Activer",
      "note": "Remarque : les clés/secrets API sont renouvelés dans l'onglet Sécurité — cet onglet active/désactive seulement les passerelles.",
      "twilio": "Twilio (passerelle SMS)",
      "vonage": "Vonage (passerelle SMS de secours)",
      "sendgrid": "SendGrid (passerelle e-mail)",
      "fcm": "FCM (notification push)"
    },
    "dirty": {
      "unsaved": "Modifications non enregistrées",
      "version": "Version {{version}}"
    },
    "actions": {
      "discard": "Annuler les modifications",
      "saving": "Enregistrement…",
      "save": "Enregistrer les modifications"
    }
  },
  "support": {
    "loading": "Chargement des paramètres Support…",
    "loadErrorTitle": "Échec du chargement des paramètres Support",
    "loadError": "Impossible de charger les paramètres Support — veuillez réessayer.",
    "retry": "Réessayer",
    "heading": "Support",
    "description": "Configurez les SLA par priorité, les réponses prédéfinies, l'attribution automatique et les catégories par défaut pour les tickets de support.",
    "versionConflictTitle": "Version modifiée",
    "versionConflictDefault": "Les paramètres ont été mis à jour par quelqu'un d'autre pendant votre modification.",
    "versionConflictSuffix": "Veuillez recharger la page et réessayer.",
    "reload": "Recharger depuis le serveur",
    "saveErrorFallback": "Échec de l'enregistrement des paramètres Support — veuillez réessayer.",
    "saved": "Enregistré (version {{version}}).",
    "sla": {
      "legend": "SLA par priorité — unité : minutes",
      "priorityHeader": "Priorité",
      "firstResponseHeader": "Première réponse (minutes)",
      "resolutionHeader": "Résolution (minutes)",
      "validationError": "Chaque SLA doit être un entier positif (> 0 minute)."
    },
    "priorities": {
      "critical": "Critique",
      "high": "Élevée",
      "medium": "Moyenne",
      "low": "Faible"
    },
    "canned": {
      "legend": "Réponses prédéfinies",
      "empty": "Aucune réponse prédéfinie — cliquez sur « Ajouter » pour en créer une.",
      "title": "Titre",
      "remove": "Supprimer",
      "body": "Contenu (HTML — l'éditeur enrichi est amélioré dans le shell de la page)",
      "add": "+ Ajouter une réponse prédéfinie"
    },
    "autoAssign": {
      "legend": "Configuration de l'attribution automatique",
      "maxOpen": "Tickets ouverts max par admin",
      "workingStart": "Début des heures de travail",
      "workingEnd": "Fin des heures de travail",
      "timezone": "Fuseau horaire (IANA)",
      "timezonePlaceholder": "Asia/Bangkok"
    },
    "categories": {
      "legend": "Catégories de tickets par défaut",
      "list": "Liste des catégories (séparées par des virgules)"
    },
    "dirty": {
      "unsaved": "Modifications non enregistrées",
      "version": "Version {{version}}"
    },
    "actions": {
      "discard": "Annuler les modifications",
      "saving": "Enregistrement…",
      "save": "Enregistrer les modifications"
    }
  },
  "emailTemplates": {
    "title": "Modèles d'e-mail",
    "subtitle": "Gérez les modèles d'e-mail système (Auth / Orders / Billing / System / …) avec l'i18n EN / VI / FR.",
    "create": "Créer un modèle",
    "filters": {
      "categoryLabel": "Catégorie",
      "allCategories": "Toutes",
      "searchLabel": "Rechercher par nom",
      "searchPlaceholder": "Confirmation de commande…"
    },
    "columns": {
      "name": "Nom",
      "category": "Catégorie",
      "subjectEn": "Objet (EN)",
      "languages": "Langues",
      "lastUpdated": "Dernière mise à jour",
      "actions": "Actions"
    },
    "loading": "Chargement…",
    "empty": "Aucun modèle pour l'instant — cliquez sur « {{action}} » pour commencer.",
    "rowActions": {
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "confirmDelete": "Supprimer le modèle « {{name}} » ? Il sera masqué de la liste.",
    "toast": {
      "deletedTitle": "Modèle supprimé",
      "deleteFailedTitle": "Échec de la suppression du modèle"
    },
    "badge": {
      "complete": "{{loc}} complet",
      "missing": "{{loc}} manquant"
    },
    "categoryLabels": {
      "Auth": "Authentification",
      "Orders": "Commandes",
      "Billing": "Facturation",
      "System": "Système",
      "Vendor": "Fournisseur",
      "Merchant": "Marchand",
      "Store": "Boutique",
      "Support": "Support"
    }
  },
  "emailTemplateEditor": {
    "untitledTemplate": "modèle",
    "subjectLabel": "Objet ({{locale}})",
    "bodyLabel": "Corps ({{locale}})",
    "bodyAriaLabel": "Corps de l'e-mail {{locale}}",
    "previewTextLabel": "Texte d'aperçu",
    "footer": {
      "preview": "Aperçu",
      "testSend": "Envoi de test"
    },
    "variables": {
      "heading": "Variables",
      "keyAriaLabel": "Clé de variable",
      "keyPlaceholder": "order_id",
      "descAriaLabel": "Description de la variable",
      "descPlaceholder": "ID public de la commande"
    },
    "categoryLabels": {
      "Auth": "Authentification",
      "Orders": "Commandes",
      "Billing": "Facturation",
      "System": "Système",
      "Vendor": "Fournisseur",
      "Merchant": "Marchand",
      "Store": "Boutique",
      "Support": "Support"
    }
  },
  "profile": {
    "card": {
      "title": "Informations du compte",
      "description": "Mettez à jour votre nom, numéro de téléphone, fuseau horaire et avatar. Toutes les modifications sont enregistrées dans le journal d'audit."
    },
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "phone": "Numéro de téléphone",
      "phonePlaceholder": "+84xxxxxxxxx",
      "timezone": "Fuseau horaire",
      "avatarUrl": "URL de l'avatar",
      "avatarUrlPlaceholder": "https://…",
      "language": "Langue"
    },
    "success": "Modifications enregistrées.",
    "buttons": {
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement…"
    }
  },
  "changePassword": {
    "card": {
      "title": "Changer le mot de passe",
      "description": "Il s'agit d'une action sensible — il pourra vous être demandé de vous reconnecter après la mise à jour."
    },
    "rules": {
      "len": "Au moins 12 caractères",
      "upper": "Au moins 1 lettre majuscule",
      "num": "Au moins 1 chiffre",
      "special": "Au moins 1 caractère spécial"
    },
    "validation": {
      "currentRequired": "Veuillez saisir votre mot de passe actuel",
      "newMin": "Le mot de passe doit comporter au moins 12 caractères",
      "newUpper": "Au moins 1 lettre majuscule requise",
      "newNum": "Au moins 1 chiffre requis",
      "newSpecial": "Au moins 1 caractère spécial requis",
      "confirmRequired": "Veuillez confirmer votre mot de passe",
      "mismatch": "La confirmation du mot de passe ne correspond pas",
      "sameAsCurrent": "Le nouveau mot de passe doit être différent de l'actuel"
    },
    "fields": {
      "current": "Mot de passe actuel",
      "new": "Nouveau mot de passe",
      "confirm": "Confirmer le nouveau mot de passe"
    },
    "rulesAria": "Exigences du mot de passe",
    "errors": {
      "invalid": "Le mot de passe actuel est incorrect ou la session a expiré.",
      "reused": "Ce mot de passe a été utilisé récemment. Veuillez en choisir un autre.",
      "generic": "Échec de la requête (HTTP {{status}})",
      "unknown": "Erreur inconnue"
    },
    "success": "Mot de passe modifié avec succès.",
    "buttons": {
      "update": "Mettre à jour le mot de passe",
      "updating": "Mise à jour..."
    }
  },
  "billingInfo": {
    "card": {
      "title": "Entreprise",
      "description": "Champs sensibles — authentification récente requise (fresh perms — une session ré-authentifiée au cours des 5 dernières minutes). Le système actualise automatiquement si la session a expiré."
    },
    "fields": {
      "businessName": "Nom de l'entreprise",
      "taxId": "Numéro fiscal (Tax ID)",
      "billingEmail": "E-mail de facturation",
      "line1": "Adresse (ligne 1)",
      "city": "Ville",
      "postalCode": "Code postal",
      "country": "Pays"
    },
    "address": {
      "legend": "Adresse de facturation"
    },
    "countries": {
      "VN": "Vietnam",
      "US": "États-Unis",
      "SG": "Singapour",
      "TH": "Thaïlande",
      "JP": "Japon",
      "GB": "Royaume-Uni",
      "FR": "France"
    },
    "errors": {
      "needAtLeastOne": "Veuillez saisir au moins un champ à mettre à jour."
    },
    "success": "Informations de facturation enregistrées.",
    "buttons": {
      "save": "Enregistrer les informations",
      "saving": "Enregistrement…"
    }
  },
  "preferences": {
    "card": {
      "title": "Apparence et notifications",
      "description": "Thème, langue et canaux de notification. Le thème est enregistré à la fois dans le localStorage et la base de données (persistance multi-appareils — synchronisé entre vos appareils)."
    },
    "fields": {
      "theme": "Thème",
      "language": "Langue"
    },
    "themeOptions": {
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "notifications": {
      "legend": "Notifications",
      "emailDigest": "Recevoir les e-mails de synthèse",
      "inApp": "In-app (cloche dans la barre supérieure)",
      "emailPerEvent": "E-mail pour chaque événement",
      "sms": "SMS"
    },
    "success": "Préférences enregistrées.",
    "buttons": {
      "save": "Enregistrer les préférences",
      "saving": "Enregistrement…"
    }
  },
  "securityCenter": {},
  "setup2fa": {
    "card": {
      "title": "Sécurité du compte",
      "description": "Choisissez une méthode 2FA — TOTP (via une application comme Google Authenticator) ou OTP par e-mail. Action sensible — authentification récente de moins de 5 minutes requise."
    },
    "fields": {
      "method": "Méthode",
      "code": "Saisissez le code à 6 chiffres"
    },
    "methodOptions": {
      "totp": "TOTP (App)",
      "email": "OTP par e-mail"
    },
    "buttons": {
      "disable": "Désactiver la 2FA",
      "processing": "Traitement…",
      "startEnroll": "Commencer la configuration",
      "cancel": "Annuler",
      "verify": "Vérifier le code",
      "verifying": "Vérification…",
      "done": "Terminer",
      "download": "Télécharger les codes",
      "copy": "Copier",
      "copied": "Copié"
    },
    "enroll": {
      "totpHint": "Scannez le QR code avec une application TOTP, ou saisissez le secret manuellement :",
      "qrAlt": "QR code TOTP pour la 2FA",
      "secretLabel": "Secret : {{secret}}",
      "emailHintBefore": "Un code OTP a été envoyé à ",
      "emailFallback": "votre e-mail",
      "emailHintAfter": ". Le code expire dans 10 minutes."
    },
    "recovery": {
      "successBold": "2FA activée avec succès.",
      "note": " Conservez les codes de récupération ci-dessous en lieu sûr — ils ne sont affichés qu'une seule fois."
    },
    "disabled": {
      "message": "2FA désactivée. Réactivez-la rapidement pour protéger votre compte."
    },
    "errors": {
      "impersonateSetup": "Impossible de configurer la 2FA pendant une session d'usurpation d'identité.",
      "impersonateDisable": "Impossible de désactiver la 2FA pendant une session d'usurpation d'identité.",
      "wrongPassword": "Le mot de passe est incorrect."
    },
    "status": {
      "enabledTitle": "L'authentification à deux facteurs est activée",
      "enabledDesc": "Votre compte est protégé par la 2FA. Vous pouvez la désactiver ci-dessous si nécessaire."
    },
    "disableConfirm": {
      "passwordLabel": "Saisissez votre mot de passe pour désactiver la 2FA",
      "passwordPlaceholder": "Mot de passe actuel"
    },
    "trustedDevices": {
      "title": "Appareils de confiance",
      "description": "Les appareils que vous avez approuvés ignorent le code 2FA à la connexion. Révoquez ceux que vous ne reconnaissez pas.",
      "current": "Cet appareil",
      "revoke": "Révoquer",
      "unknownDevice": "Appareil inconnu",
      "empty": "Aucun appareil de confiance."
    }
  },
  "roles": {
    "noPermBefore": "Vous n'avez pas l'autorisation de voir la liste des rôles (nécessite ",
    "noPermAfter": "). Contactez un Super Admin pour obtenir l'accès.",
    "listErrorFallback": "Impossible de charger la liste des rôles",
    "header": {
      "title": "Rôles et permissions",
      "subtitle": "Gérez les rôles + la matrice des permissions pour admin/super admin (System > Roles)."
    },
    "createCta": "+ Créer un rôle personnalisé",
    "toast": {
      "noPermTitle": "Permissions insuffisantes",
      "noPermDesc": "Seul un Super Admin peut créer un rôle personnalisé.",
      "createdTitle": "Rôle créé",
      "createdDesc": "Le nouveau rôle a été ajouté à la liste."
    },
    "listHeader": "Liste des rôles",
    "loading": "Chargement…",
    "emptyList": "Aucun rôle pour le moment.",
    "badge": {
      "builtIn": "Intégré",
      "custom": "Personnalisé"
    },
    "rowMeta": "{{permissions}} permissions · {{members}} membres",
    "tablistAria": "Onglets Rôles et permissions",
    "tabs": {
      "matrix": "Matrice des permissions",
      "data": "Permissions de données"
    },
    "viewingLabel": "Affichage :",
    "overrideHintBefore": "Besoin d'un remplacement au niveau utilisateur (additionalPermissions / deniedPermissions) ? Accédez à ",
    "overrideHintAfter": " pour configurer par utilisateur."
  },
  "conflictDiff": {
    "aria": "Le serveur a une version plus récente",
    "title": "Le serveur a une version plus récente",
    "description": "Un autre administrateur a mis à jour ces paramètres pendant que vous les modifiiez. Le serveur est désormais à la version v{{currentVersion}} mais votre brouillon est basé sur la v{{expectedVersion}}. Choisissez Recharger pour abandonner vos modifications et repartir des valeurs du serveur, ou Forcer l'écrasement pour rejouer votre correctif sur la version actuelle (journalisé pour audit).",
    "noDiffs": "Aucune différence détectée — seule la version diffère.",
    "columns": {
      "field": "Champ",
      "yourValue": "Votre valeur",
      "serverValue": "Valeur du serveur"
    },
    "reload": "Recharger les valeurs du serveur",
    "forceOverwrite": "Forcer l'écrasement"
  },
  "stickySaveBar": {
    "aria": "Modifications non enregistrées",
    "unsavedChanges": "Vous avez des modifications non enregistrées.",
    "save": "Enregistrer les modifications",
    "discard": "Annuler",
    "saving": "Enregistrement…",
    "readonly": "Lecture seule (aucune autorisation d'écriture)"
  },
  "useSettings": {
    "loadFailTitle": "Échec du chargement des paramètres",
    "loadFailFallback": "Impossible de charger les paramètres. Veuillez réessayer.",
    "nothingToSaveTitle": "Rien à enregistrer",
    "nothingToSaveDesc": "Aucun champ modifié depuis le dernier enregistrement.",
    "savedTitle": "Paramètres enregistrés",
    "savedDesc_one": "{{count}} champ mis à jour.",
    "savedDesc_other": "{{count}} champs mis à jour.",
    "conflictTitle": "Le serveur a une version plus récente",
    "conflictDesc": "Un autre administrateur a mis à jour ces paramètres. Vérifiez les différences.",
    "saveFailTitle": "Échec de l'enregistrement",
    "saveFailFallback": "Impossible d'enregistrer les paramètres. Veuillez réessayer."
  }
}